import React from 'react';
import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';
import { Button, Grid } from '@mui/material';
import { linkWithQueryParams } from '../../services/urls';
import { LOGIN_ROUTE } from '../../services/routes';
import ProductPreviewCard from './product_preview_card';
import AlreadyAMemberButton from '../onboarding/already_a_member_button';
import { useGetPublicSpaceQuery } from '../../app/smorgAppSyncGraphQLApi';
import { useGetCurrentSpaceMembershipQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { SPACE_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const SpaceLandingPageContent = ({ showSignupControls, onClickJoin }) => {
  const { spaceId } = useParams();

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery();

  const { data: currentSpace } = useGetPublicSpaceQuery(spaceId, {
    skip: !spaceId,
    refetchOnMountOrArgChange: SPACE_REFRESH_INTERVAL_SECONDS,
  });

  const currentSpaceMembershipSpaceID = currentSpaceMembership?.spaceID;

  const currentSpaceMembershipTierID = currentSpaceMembership?.membershipTierID;

  const isAlreadyAMember =
    currentSpaceMembershipSpaceID /* Logged in */ &&
    (currentSpaceMembershipSpaceID !==
      spaceId /* Member of a different space */ ||
      !!currentSpaceMembershipTierID); /* Member of this space with an assigned membership tier */

  if (!currentSpace) {
    return null;
  }

  return (
    <div
      className="landingPageContent"
      style={{ maxWidth: '1000px', margin: '0 auto' }}>
      {currentSpace?.landingPageCoverImageUrl && (
        <div
          className="landingPageCoverImage"
          style={{
            backgroundImage: `url("${currentSpace?.landingPageCoverImageUrl}")`,
            backgroundSize: 'cover',
          }}>
          &nbsp;
        </div>
      )}
      <div
        style={{ paddingLeft: '15px', paddingRight: '15px' }}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: currentSpace.landingPageContent }}
      />
      {showSignupControls &&
        (isAlreadyAMember ? (
          <AlreadyAMemberButton spaceID={spaceId} />
        ) : (
          <>
            <Button
              onClick={onClickJoin}
              variant="contained"
              size="medium"
              disableElevation
              style={{
                borderRadius: '30px',
                backgroundColor:
                  currentSpace.whiteLabelElements.primaryMainColor,
                paddingLeft: '30px',
                paddingRight: '30px',
                fontSize: '16px',
                fontWeight: '800',
              }}>
              Join
            </Button>
            <br />
            <br />
            <div>
              <Link
                to={linkWithQueryParams(LOGIN_ROUTE, {
                  intoSpace: currentSpace.id,
                })}>
                Already a member?
              </Link>
            </div>
          </>
        ))}
      {(currentSpace.productPreviewSections || []).map(
        (productPreviewSection) => (
          <div
            key={productPreviewSection.title}
            style={{
              padding: 10,
              paddingLeft: 10,
              marginTop: 20,
              marginBottom: 20,
              color: 'var(--app-primary-font-color)',
            }}>
            <h3>{productPreviewSection.title}</h3>
            <Grid container spacing={2}>
              {productPreviewSection.productPreviews.map((productPreview) => (
                <Grid
                  item
                  key={productPreview.id}
                  xs={6}
                  sm={4}
                  style={{ display: 'flex' }}>
                  <ProductPreviewCard
                    key={productPreview.productObjectID}
                    title={productPreview.title}
                    shortDescription={productPreview.shortDescription}
                    coverImageUrl={productPreview.coverImageUrl}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        ),
      )}
    </div>
  );
};

SpaceLandingPageContent.propTypes = {
  showSignupControls: PropTypes.bool,
  onClickJoin: PropTypes.func,
};

SpaceLandingPageContent.defaultProps = {
  showSignupControls: false,
  onClickJoin: () => {},
};

export default SpaceLandingPageContent;
